import { Images } from '../assets'
import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {

  const currentYear = new Date().getFullYear();


  return (
    <>
      <div className="jumbotron p-4 py-12 md:p-28 flex flex-col md:flex-row justify-between gap-8 md:gap-0 md:items-center hidden">
          <div className='flex flex-col gap-6'>
              <h4 data-aos="fade-up" className="heading-three md:w-3/5">
                Transform Your Business with Our Software Solutions
              </h4>
              <p data-aos="fade-up" className='md:w-4/5'>
                Experience a new level of efficiency and growth with our custom software solutions. Stay ahead of the competition and harness technology to your advantage
              </p>
          </div>
          
          <div data-aos="fade">
            <Link to={"/get-in-touch"} className='btn btn-primary w-max'>Contact us <img decoding="async" src={Images.ArrowUpRight} alt="" loading="lazy" /></Link>
          </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-8 md:px-12 pb-4">

      <footer className='mt-16 grid grid-cols-1 md:grid-cols-2 gap-2  md:flex-row'>
            <div className='md:w-2/4'>
                <Link to={'/'}><img decoding="async" src={Images.SeamhealthLogoAlt} alt="" loading="lazy" /></Link>
                <div className="about-desc mt-3">
                  SeamHealth is a leader in healthcare innovation, dedicated to providing comprehensive consulting and software development services                
                </div>
                <Link to={"/about"} aria-label="Explore Our Story" className='btn-link' >Continue Reading</Link>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-3 mt-8 md:mt-0 gap-12'>
              <div className='w-full'>
                  <h6>Company</h6>
                  <ul className='mt-6'>
                    <Link to="/about">
                      <li className='nav-link'>About us</li>
                    </Link>
                    <Link to={"/get-in-touch"}>
                      <li className='nav-link mt-4'>Contact</li>
                    </Link>
                    <Link to={"/services"}>
                      <li className='nav-link mt-4'>Services</li>
                    </Link>
                    <Link to={"/projects"}>
                      <li className='nav-link mt-4'>Projects</li>
                    </Link>
                    <Link to={"/publications"}>
                      <li className='nav-link mt-4'>Publications</li>
                    </Link>
                  </ul>
              </div>

              <div className=''>
                  <h6>Projects</h6>
                  <ul className='mt-6'>
                    <Link to="/projects/clientshot-nthrip">
                      <li className='nav-link mt-4'>Clientshot</li>
                    </Link>
                    <Link to="/projects/bridge">
                      <li className='nav-link mt-4'>BRIDGE</li>
                    </Link>
                    <Link to="/projects/cleft-surgery">
                      <li className='nav-link mt-4'>SmileTrain</li>
                    </Link>
                    <Link to="/projects/opencrvs">
                      <li className='nav-link mt-4'>OpenCRVS</li>
                    </Link>
                    <Link to="/projects/ekiti">
                      <li className='nav-link mt-4'>Ekiti Health</li>
                    </Link>
                    <Link to="/projects/kncv">
                      <li className='nav-link mt-4'>KNCV</li>
                    </Link>
                  </ul>
              </div>


              <div className=''>
                  <h6>Services</h6>
                  <ul className='mt-6'>
                    <Link to="/services/digital-health-systems">
                      <li className='nav-link'>Digital Health Systems</li>
                    </Link>
                    <Link to="/services/health-data-analytics">
                      <li className='nav-link mt-4'>Health Data and Analytics</li>
                    </Link>
                    <Link to="/services/implementation-advisory">
                      <li className='nav-link mt-4'>Implementation and Advisory</li>
                    </Link>
                  </ul>
              </div>

             
            </div>
        </footer>

        <div className="flex flex-col md:flex-row md:justify-between items-center gap-y-8 mt-16">
          <div className="socials flex gap-4">
              <a href="https://www.instagram.com/seamhealth/profilecard/?igsh=MTZ1bmRzN3VxdHVnOA%3D%3D" target='_blank' rel='noreferrer'><img decoding="async" src={Images.InstagramIcon} alt="" loading="lazy" /></a>
              <a href="https://www.linkedin.com/company/seamhealth/" target='_blank' rel='noreferrer'><img decoding="async" src={Images.LinkedinIcon} alt="" loading="lazy" /></a>
              <a href="https://www.facebook.com/seamhealth?mibextid=ZbWKwL" target='_blank' rel='noreferrer'><img decoding="async" src={Images.FacebookIcon} alt="" loading="lazy" /></a>
          </div>

          <div className="copyright flex flex-row items-center gap-8">
          <p className='text-center' style={{color : '#8F8F8F'}}>© 2016 - {currentYear}, Seamhealth Innovations. All Rights Reserved </p>
          
          </div>

          {/* <Link to={'/sitemap.xml'}>
              <p className='nav-link'>Site map</p>
            </Link> */}
        </div>
      </div>
    </>
  )
}

export default Footer